// Regional indicator symbol offset: 'A' (65) maps to U+1F1E6 (127462).
const RI_OFFSET = 0x1F1E6 - 65;

/**
 * Convert an ISO-3166 alpha-2 country code to its flag emoji via regional-
 * indicator pair arithmetic. No image assets, no network.
 *
 * Returns '🌐' for codes that cannot be represented (length ≠ 2, non-alpha).
 *
 * @param {string} code - Two-letter country code, upper or lower case (e.g. 'jp', 'US').
 * @returns {string} Flag emoji string (e.g. '🇯🇵') or '🌐' fallback.
 */
export function flagEmoji(code) {
  if (!code || code.length !== 2) return '🌐';
  const upper = code.toUpperCase();
  const a = upper.charCodeAt(0);
  const b = upper.charCodeAt(1);
  if (a < 65 || a > 90 || b < 65 || b > 90) return '🌐';
  return String.fromCodePoint(RI_OFFSET + a) + String.fromCodePoint(RI_OFFSET + b);
}
